import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { ThreadView, Toast } from "../pages/AIConversations";

// Modal wrapper around the AIConversations ThreadView. Mounted from
// /contacts so clicking the per-row "AI Conversation" button opens the
// same per-contact thread that the All Conversations subtab would route
// you to, without leaving the contacts page.
export default function AIConversationModal({ contactKey, onClose, onOwnershipChange, externalTags, onTagsChange, onActioned }) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768,
  );
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Lock background scroll while the modal is open.
  useEffect(() => {
    if (!contactKey) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [contactKey]);

  // Close on Escape, mirroring the other modals in this app.
  useEffect(() => {
    if (!contactKey) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [contactKey, onClose]);

  if (!contactKey) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 10000,
        // Offset the overlay by the desktop sidebar width (260px, see
        // components/MainNav.js) so the modal centres within the content
        // pane to the right of the nav, not the whole viewport. On mobile
        // the sidebar is a slide-out drawer so we cover the full width.
        left: isMobile ? 0 : 260,
        background: "rgba(0,0,0,0.4)", backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "stretch" : "center",
        padding: isMobile ? 0 : 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: isMobile ? 0 : 16,
          width: "100%",
          maxWidth: isMobile ? "none" : 880,
          height: isMobile ? "100%" : "auto",
          maxHeight: isMobile ? "100%" : "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          overflow: "hidden",
        }}
      >
        {/* Header — just a close button; ThreadView renders its own header. */}
        <div style={{
          display: "flex", justifyContent: "flex-end",
          padding: "12px 16px 0", flexShrink: 0,
        }}>
          <button
            onClick={onClose}
            title="Close"
            style={{
              background: "none", border: "none", cursor: "pointer", padding: 6,
              color: "#9ca3af", fontSize: 16,
            }}
          >
            <FaTimes />
          </button>
        </div>

        <div style={{
          flex: 1, minHeight: 0, overflowY: "auto",
          padding: isMobile ? "8px 16px 24px" : "8px 24px 24px",
        }}>
          <ThreadView
            contactKey={contactKey}
            onBack={onClose}
            setToast={setToast}
            onActioned={onActioned || (() => {})}
            onOwnershipChange={onOwnershipChange}
            externalTags={externalTags}
            onTagsChange={onTagsChange}
            hideBack
            hideNotes
          />
        </div>

        <Toast toast={toast} onClose={() => setToast(null)} />
      </div>
    </div>
  );
}
